import * as React from 'react';
import { Typography, Box } from '@mui/material';
import { connect } from "react-redux";
import { resetPassword } from '../../app/store/actions/authActions';
import { useParams } from "react-router-dom";
import { MainPassword } from '../../app/components/Styles';
import { MarketingFormPage, MarketingButton } from '../../app/components/marketing';

export const ResetPassword = ({ resetPassword, user, isLoading }) => {
    const { token } = useParams();
    const [error, setError] = React.useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if (data.get("password") !== data.get("password-confirm")) {
            setError("Passwords Do Not Match");
        } else {
            resetPassword({ password: data.get('password'), token });
        }
    };

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Reset password"
            subtitle="Choose a new password for your account"
            loading={isLoading}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
                {error && (
                    <Typography role="alert" sx={{ color: 'error.main', mb: 2, fontSize: '0.875rem' }}>
                        {error}
                    </Typography>
                )}
                <MainPassword
                    margin="normal"
                    sx={{ my: 1 }}
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="new-password"
                />
                <MainPassword
                    margin="normal"
                    sx={{ my: 1 }}
                    required
                    fullWidth
                    name="password-confirm"
                    label="Confirm password"
                    type="password"
                    id="password-confirm"
                    error={error}
                />
                <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                    Save new password
                </MarketingButton>
            </Box>
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.wait?.isLoading,
});

const mapDispatchToProps = { resetPassword };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
